import { usePage } from "@inertiajs/react";

import TextLink from "@/components/text-link";
export function FreeTrialBanner() {
  const { trial } = usePage().props;

  if (!trial?.trialing) return null;

  const daysLeft = Math.max(trial.days_left ?? 0, 0);
  const daysLabel = `${daysLeft} day${daysLeft === 1 ? "" : "s"}`;
  const leadingCopy = daysLeft > 14 ? "Your free trial ends in " : "You have ";

  return (
    <div className="bg-neutral-900 px-4 py-2 text-xs font-medium text-white sm:flex sm:items-center sm:justify-center sm:text-sm">
      <div className="flex flex-wrap items-center justify-center gap-2">
        <span className="text-center sm:text-left">
          {leadingCopy}
          <span className="font-semibold whitespace-nowrap">{daysLabel}</span>
          {daysLeft > 14 ? "." : " left in your free trial."}
        </span>
        <TextLink
          href="/subscribe"
          className="font-semibold text-white underline decoration-orange-500 dark:decoration-orange-400"
        >
          Pick a plan
        </TextLink>
      </div>
    </div>
  );
}
